import { useMutation } from '@tanstack/react-query';
import { CreateUserEntity, UserWalletManageService } from 'services/openapi';

type CreateUserMutationVariables = {
  /**
   * Phone number
   */
  phoneNumber: string;
  /**
   * Fullname of user
   */
  fullName: string;
  /**
   * Email of user
   */
  email: string;
  /**
   * Citizen Identity Card No of user
   */
  citizenIdentityCardNo: string;
  /**
   * BIDV Virtual Account Payer ID
   */
  bidvVaPayerId: string;
  /**
   * BIDV Virtual Account Name
   */
  vaName: string;
  /**
   * Role of user
   */
  role: 'Agency' | 'Admin' | 'SpAdm' | 'OilMc' | 'ZOMc';
  /**
   * Company of user
   */
  compId?: string;
  /**
   * Status of user
   */
  isActive: boolean;
  /**
   * User back account number
   */
  accountNumber: string;
  /**
   * Doi tuong
   */
  objectType: 'Driver' | 'Staff' | 'Partner' | 'Customer';
  adminActions?: Array<string>;
};

export const useCreateUserMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<any, Error, CreateUserMutationVariables>({
      mutationFn: (variables: CreateUserMutationVariables) => {
        return UserWalletManageService.userManageControllerCreateUser(
          variables,
        );
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
